import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import isEqual from "lodash-es/isEqual";
import { Dropdown, DropdownItem } from "../common/Dropdown";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function FilterDropdown(props) {
  const options = props.options.flatMap(option => {
    return option.children;
  });
  const selected = options.filter(option => props.selected.some(selected => isEqual(selected, option.value)));
  const selectedLabels = selected.map(option => option.label);
  const selectedValues = selected.map(option => option.value);
  let selectedLabel = "All";
  if (selectedLabels.length === 1) {
    selectedLabel = selectedLabels[0];
  } else if (selectedLabels.length > 1) {
    selectedLabel = "Multiple";
  }
  return /*#__PURE__*/_jsx(Dropdown, {
    label: selectedLabel,
    options: props.options,
    keepOpen: true,
    headerElement: close => /*#__PURE__*/_jsx("button", {
      className: "relative w-[340px] py-2 pl-2 pr-10 text-left hover:bg-grey-100",
      onClick: () => {
        props.onChange([]);
        close();
      },
      children: "All"
    }),
    renderItem: item => {
      const anyChildrenSelected = item.children.some(child => props.selected.some(value => isEqual(value, child.value)));
      return /*#__PURE__*/_jsx(Disclosure, {
        defaultOpen: anyChildrenSelected,
        children: /*#__PURE__*/_jsxs("div", {
          className: "relative mt-1",
          children: [/*#__PURE__*/_jsx(Disclosure.Button, {
            className: "relative w-full py-2 pl-2 pr-10 text-left hover:bg-grey-100",
            children: _ref => {
              let {
                open
              } = _ref;
              const Icon = open ? ChevronUpIcon : ChevronDownIcon;
              return /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("span", {
                  className: "block truncate",
                  children: item.label
                }), /*#__PURE__*/_jsx("span", {
                  className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
                  children: /*#__PURE__*/_jsx(Icon, {
                    className: "h-5 w-5 text-gray-400",
                    "aria-hidden": "true"
                  })
                })]
              });
            }
          }), /*#__PURE__*/_jsx(Disclosure.Panel, {
            className: "mt-1 w-full overflow-auto p-2",
            children: item.children.map((child, j) => {
              const isSelected = props.selected.some(value => isEqual(value, child.value));
              const onTrigger = () => {
                let newSelected = [...selectedValues];

                // clear sibling options if allowMultiple is false
                if (item.allowMultiple === false) {
                  newSelected = newSelected.filter(option => !item.children.some(child => isEqual(child.value, option)));
                }
                if (!isSelected) {
                  newSelected.push(child.value);
                } else {
                  newSelected = newSelected.filter(option => {
                    return !isEqual(option, child.value);
                  });
                }
                props.onChange(newSelected);
              };

              // HeadlessUI binds onclick so clicking the label doesn't work to trigger the checkbox
              return /*#__PURE__*/_jsxs(DropdownItem, {
                $as: "label",
                onClick: e => {
                  e.preventDefault();
                  onTrigger();
                },
                className: `block truncate ${isSelected ? "font-medium" : "font-normal"}`,
                children: [/*#__PURE__*/_jsx("input", {
                  type: "checkbox",
                  className: "mr-2",
                  checked: isSelected,
                  onChange: () => {
                    // do nothing
                  },
                  onClick: e => {
                    e.stopPropagation();
                    onTrigger();
                  }
                }), child.label]
              }, j);
            })
          })]
        })
      });
    }
  });
}